import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    alignContent: "center",
    justifyContent: "center",
  },
  loading: { width: "auto", alignSelf: "center" },
});
